import type {HistoryMaterialStorage} from '@domain/material-storage'
import {MaterialType} from '@domain/material-storage'

interface useAttachedStoragesParams {
  storagesById: Record<string, HistoryMaterialStorage>
  availableStorages: HistoryMaterialStorage[]
  selectedSilosIds: number[]
}

export const useAttachedStorages = ({
  storagesById,
  availableStorages,
  selectedSilosIds
}: useAttachedStoragesParams) => {
  const availableStoragesIds = availableStorages.map(({id}) => id)

  const selectedAvailableStoragesIds = availableStoragesIds.filter((storageId) =>
    selectedSilosIds.includes(storageId)
  )

  const notSelectedAvailableStoragesIds = availableStoragesIds.filter(
    (storageId) => !selectedSilosIds.includes(storageId)
  )

  const remainingStorages = Object.values(storagesById)
    .filter((storage) => !availableStoragesIds.includes(storage.id))
    .filter((storage) => storage.materialType === MaterialType.Cement)
    .sort((a, b) => a.name.localeCompare(b.name))

  const selectedRemainingStorages = remainingStorages.filter((storage) =>
    selectedSilosIds.includes(storage.id)
  )
  const selectedRemainingStoragesIds = selectedRemainingStorages.map((storage) => storage.id)

  const selectedStorages = [...availableStorages, ...selectedRemainingStorages]
    .map((storage) => ({
      ...storage,
      isSelected: selectedSilosIds.includes(storage.id)
    }))
    .sort((a, b) => a.name.localeCompare(b.name))

  const selectedStoragesOrdered = [...selectedSilosIds, ...notSelectedAvailableStoragesIds].map(
    (id) => ({
      ...storagesById[id],
      isSelected: selectedSilosIds.includes(id)
    })
  )

  return {
    selectedStorages,
    selectedStoragesOrdered,
    selectedAvailableStoragesIds,
    selectedRemainingStoragesIds,
    remainingStorages
  }
}
